export class PluginService {
  constructor(data) {
    this.data = data;
  }

  async updatePlugins(knowledgeId, plugins) {
    return this.data.updatePlugins(knowledgeId, plugins);
  }
}
